import { useMutation } from '../index';
import { gql } from '@apollo/client';
import permissions from '../Apollo/permissions';

const mutation = gql`
  mutation RemoveAnalyticsFile($analyticsFileId: uuid!) {
    delete_analytics_files_by_pk(id: $analyticsFileId) {
      id
      settings
      identitySyncs
      integrations
    }
  }
`;

export default (options = {}) => {
  const [call, response] = useMutation(mutation, {
    ...options,
    context: { permission: permissions.updatePipelineAJSBuilder },
  });
  return [
    ({ analyticsFileId }) => {
      return call({
        variables: {
          analyticsFileId,
        },
      });
    },
    response,
  ];
};
